export default "__VITE_ASSET__4e2f36b0__"